import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { ITechnologies } from "../technologyModal";

export const getAllTechnologies = createAsyncThunk(
  "Technologies/FindAllTechnologies",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Technologies/FindAllTechnologies`,
        {
          TechnologiesTitle: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Technologies:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createTechnology = createAsyncThunk(
  "Technologies/InsertTechnology",
  async (TechnologiesData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Technologies/InsertTechnology`,
        TechnologiesData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Technology:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateTechnologies = createAsyncThunk(
  "Technologies/UpdateTechnology",
  async (TechnologiesData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Technologies/UpdateTechnology`,
        TechnologiesData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Technology:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteTechnologies = createAsyncThunk(
  "Technologies/DeleteTechnology",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Technologies/DeleteTechnology`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Technologies :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getTechnologiesByID = createAsyncThunk(
  "Technologies/FindByIDTechnology",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Technologies/FindByIDTechnology`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        ServiceID: result.ServiceID ? +result.ServiceID : "",
        Title: result.Title ? result.Title : "",
        Subtitle: result.Subtitle ? result.Subtitle : "",
        Description: result.Description ? result.Description : "",
        IsActive: result.IsActive ? 1 : 2,
      } as ITechnologies;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Technology :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveTechnologies = createAsyncThunk(
  "Technologies/FindAllActiveTechnology",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Technologies/FindAllActiveTechnology`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Technologies:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveTechnologies = createAsyncThunk(
  "Technologies/ActiveInActiveTechnology",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Technologies/ActiveInActiveTechnology`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Technologies :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

// IMAGE UPLOAD

export const TechnologyDetailsImageUpload = createAsyncThunk(
  "Technologies/TechnologiesImageUpdate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Technologies/TechnologiesImageUpdate`,
        formData,
        {
          headers: { "content-type": "multipart/form-data" },
        }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error upload Technologies Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
